<div class="pageHeader">
    <div class="link-back">
        <a class="cosentino-link primaryDefault-color typography-body-m-regular" gtm-usertype="ad" target="_self" [attr.data-gtm-label]="'link_back-to-my-galleries'" (click)="this.goBack()">
            <div class="maxContent">
                <div class="link-container">
                    <svg width="24" height="24"  viewBox="0 0 24 24" fill="none" 
                            xmlns="http://www.w3.org/2000/svg">
                        <path class="primaryDefault" d="M14.0002 17.3L8.7002 12L14.0002 6.69995L14.7002 7.39995L10.1002 12L14.7002 16.6L14.0002 17.3Z" fill="#232323"></path>
                    </svg>
                    <span>
                        {{ 'my_galleries.come_back_to_my_galleries' | translate }}
                    </span>
                </div>
            </div>
        </a>
    </div>
    <div class="title status">
        <section *ngIf="gallery" class="flexible-column">
            <div class="titleTextName">
                <h2 class="title-container typography-title-l" data-id="changeNameName">
                    <span *ngIf="gallery.id">
                        {{ gallery.name }}
                    </span>
                    <span *ngIf="!gallery.id">
                        {{ 'my_galleries.new_gallery_title' | translate }}
                    </span>
                </h2>
            </div>
            <div class="badge-container">
                <div data-id="container-class" class="status-icon-container typography-body-m-regular gallery draft">
                    <div data-id="status-icon" class="status-icon gallery" [style.background-color]="getStatusColor(gallery.status)"></div>
                    <span data-id="status-span" class="font-bold" [style.color]="getStatusColor(gallery.status)">
                        {{ 'status-gallery.' + gallery.status | translate }}
                    </span>
                </div>
            </div>
        </section>
    </div>
</div>

<app-confirm-modal class="confirmModal" confirmButtonStyle='primary' cancelButtonStyle='ghost' [isOpen]="this.isConfirmModalOpen" title="{{ 'new-galleries.modal_confirm' | translate }}"
                   confirmText="{{ 'my_profile.continue_text' | translate }}" cancelText="{{ 'my_galleries.modal_new_gallery_modal_confirm_back' | translate }}"
                   (onCancel)="this.closeConfirmModal()" (onClose)="this.closeConfirmModal()" (onConfirm)="this.goToList()" style="flex-flow: wrap; gap: inherit;"></app-confirm-modal>
